import { useEffect, useState } from "react";

import { DocumentIcon } from "@/assets/icons";
import { BenchmarksList, Pagination } from "@/components";
import { strings } from "@/constants";
import { RoleEnum } from "@/enums";
import {
    useAuth,
    useListAdminBenchmarks,
    useListCompanyBenchmarks,
} from "@/hooks";

export const BenchmarksPage = () => {
    const [currentPage, setCurrentPage] = useState(1);

    const { user } = useAuth();

    const isAdmin = user?.role === RoleEnum.ADMIN;

    const adminListAction = useListAdminBenchmarks();

    const companyListAction = useListCompanyBenchmarks();

    const activeAction = isAdmin ? adminListAction : companyListAction;

    const {
        data: page,
        isLoading,
        onRun: fetchListHandler,
    } = activeAction;

    const items = page?.items ?? [];

    const totalItems = page?.total ?? 0;

    const perPage = page?.perPage ?? 15;

    useEffect(
        () => void fetchListHandler({ page: currentPage }),
        [fetchListHandler, currentPage],
    );

    return (
        <div
            className="
                mx-auto
                w-full
                max-w-5xl
                space-y-6
            "
        >
            <div className="flex items-center gap-2 sm:gap-3">
                <DocumentIcon className="h-6 w-6 shrink-0 text-primary sm:h-7 sm:w-7" />
                <h1 className="text-xl font-bold text-text-primary sm:text-2xl">{strings.benchmarks.title}</h1>
            </div>
            <BenchmarksList
                isLoading={isLoading}
                items={items}
            />
            <Pagination
                currentPage={currentPage}
                pageSize={perPage}
                totalItems={totalItems}
                onChange={setCurrentPage}
            />
        </div>
    );
};
